import { rfqQuoteDetailsProposedDetailsGridItemStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGridItem";
import { css } from "styled-components";

Object.assign(rfqQuoteDetailsProposedDetailsGridItemStyles, {
    ...rfqQuoteDetailsProposedDetailsGridItemStyles,
    infoLeftColumn: {
        width: [12, 12, 12, 5, 5],
    },
    productPrice: {
        wrapper: {
            css: css`
                margin-top: 10px;
            `,
        },
        price: {
            priceText: {
                css: css`
                    color: #1e75ba;
                `,
            },
        },
    },
    quotedPricingGridItem: {
        width: [12, 12, 12, 4, 4],
        css: css`
            flex-direction: column;
        `,
    },
    quotedPricingText: {
        weight: 600,
        size: 15,
    },
    quantityAndSubtotalGridItem: {
        width: [12, 12, 12, 3, 3],
    },
    quantityAndSubtotalContainer: {
        gap: 20,
    },
    quantityGridItem: {
        width: [6, 6, 6, 12, 12],
    },
    subtotalGridItem: {
        width: [6, 6, 6, 12, 12],
        align: "bottom",
    },
    subtotalText: {
        weight: 600,
        size: 14,
    },
    vatLabelText: {
        size: 14,
    },
    subtotalWithoutVatText: {
        weight: "bold",
        css: css`
            margin-top: 5px;
        `,
    },
    productPartNumbers: {
        erpNumberLabelText: {
            css: css`
                font-size: 14px;
            `,
        },
        erpNumberValueText: {
            css: css`
                font-size: 14px;
            `,
        },
    },
    quotedPricingStyles: {
        priceText: {
            css: css`
                font-size: 14px;
            `,
        },
        quantityText: {
            size: 14,
        },
    },
});
